import { Divider as HeroUIDivider } from '@heroui/react';

// Full-width section separator for the converted Settings tabs, matching the divider pattern in
// ProjectSubmissionForm (a HeroUI Divider between sections). The negative margins bleed the line
// past the tab container's horizontal padding (px-4 / sm:px-10) so it spans the full panel width,
// and `w-auto` overrides HeroUI's default `w-full` so the bleed can take effect. Each section
// supplies its own vertical padding, so the divider lands centered in the gap between them.
//
// Callers must use the same px-4 / sm:px-10 container padding for the bleed to line up.
export function Divider() {
    return <HeroUIDivider className="-mx-4 w-auto sm:-mx-10" />;
}
